<template>
	<div id="warTeam" style="min-height:700px">
		<div class="bread">
			<img src="../images/icon/routerbg.png" alt="">
			<div>
				<router-link to="/"><span class="home">EDG首页</span></router-link>
				<img src="../images/icon/arrow_right.png" />
				<span>EDG战队</span>
			</div>
		</div>
		<div class="box">
			<h1 class="topword" :class="[{ animated: isActive },{ lightSpeedIn: isActive }]"><span>现役战队</span></h1>
			<img src="../images/icon/line6.png" alt="">
		</div>
		<div class="content">
			<!-- 轮播战队信息-->
			<div class="swiper-container swiper-container1 swiper-no-swiping">
				<div class="swiper-wrapper" style="text-align: center;padding-left: 20px">
					<div class="swiper-slide" v-for="(items,fatherindex) in teamData">
						<div style="display: inline-block;height: 190px;width: auto">
							<div class="Lbox" v-for="(itemi,index) in items" @click="showTeamInfo( index,itemi.id,fatherindex)">
								<img :src="itemi.imageUrl" alt="" class="Lpic"><br>
								<span class="Lword" :class="{ bgActive: index==itemiActive}">{{itemi.name}}</span>
							</div>

						</div>
					</div>
				</div>
				<!-- 如果需要导航按钮 -->
				<div :style="{  'opacity': ifShowArrow ? 1 : 0  }">
					<div class="swiper-button-prev" @click="ifshowteamInfo=true,itemiActive=-1"></div>
					<div class="swiper-button-next" @click="ifshowteamInfo=true,itemiActive=-1"></div>
				</div>
			</div>
			<div style="width:1112px;height: 6px;position: relative;margin: 0 auto" :class="{ activeteamInfo: ifshowteamInfo}">
				<div class="playerinTeam1" :class="{ activeshow: 1==showactiveshow}">现役队员</div>
				<div class="playerinTeam2" :class="{ activeshow: 2==showactiveshow}">现役队员</div>
				<div class="playerinTeam3" :class="{ activeshow: 3==showactiveshow}">现役队员</div>
				<div class="playerinTeam4" :class="{ activeshow: 4==showactiveshow}">现役队员</div>
				<div class="playerinTeam5" :class="{ activeshow: 5==showactiveshow}">现役队员</div>
				<div class="playerinTeam6" :class="{ activeshow: 6==showactiveshow}">现役队员</div>
				<div class="playerinTeam7" :class="{ activeshow: 7==showactiveshow}">现役队员</div>
				<div class="playerinTeam8" :class="{ activeshow: 8==showactiveshow}">现役队员</div>
				<div class="playerinTeam9" :class="{ activeshow: 9==showactiveshow}">现役队员</div>
				<div class="playerinTeam10" :class="{ activeshow: 10==showactiveshow}">现役队员</div>
			</div>
			<!--轮播战队队员-->
			<div class="teamInfo" :class="{ activeteamInfo: ifshowteamInfo}">
				<div class="swiper-container swiper-container2">
					<div class="swiper-wrapper" style="text-align: center;">
						<div class="swiper-slide" v-for="(itemsinfo,index1) in teamDataInfo">
							<div style="display: inline-block;height: 300px;width: auto">
								<div class="Lbox1" v-for="(itemifo,index2) in itemsinfo" @click="showallcover(index2,index1)" v-show="!ifshowteamInfo">
									<img :src="itemifo.thumbnailUrl" alt="" class="teammemberpic">
									<div style="margin-top: 8px">{{itemifo.name}}</div>
									<img src="../images/icon/line.png" alt="">
									<div style="font-size: 18px">{{itemifo.position}}</div>
								</div>
							</div>
						</div>
					</div>
					<!-- 如果需要分页器 -->
					<div class="swiper-pagination"></div>
				</div>
				`
			</div>
		</div>
		<!--全屏遮罩+队员详细信息轮播 -->
		<div v-show="allcover" id="allcover" class="bgimg" style="z-index: 1000">
			<!--<span class="remove" @click="allcover=false" style="color: white">×</span>-->
			<img class="remove" src="../images/icon/close.png" @click="allcover=false" />
			<div class="CoverBox">
				<div class="swiper-container swiper-container3">
					<div class="swiper-wrapper" style="text-align: center">
						<div class="swiper-slide" v-for="(item,index) in coverteaminfo">
							<div class="CoverBoxI">
								<div class="CBI">
									<img :src="item.imageUrl" alt="">
								</div>
								<div class="CBC">
									<!--<div :class="[{ animated:  index==activeNum },{ fadeInLeft:  index==activeNum }]">-->
									<div class="CBC1">
										<p>{{item.nickName}}</p>
										<p style="text-align: right">位置:{{item.position}}</p>
									</div>
									<div class="CBC2">
										姓名:{{item.name}} 年龄: {{tempages[index]}} 生日: {{item.birthday}} <br>
										<div>
											个人简介: <br> {{item.summary}}
										</div>
									</div>
								</div>
							</div>
						</div>

					</div>
					<!-- 如果需要导航按钮 -->
					<div class="swiper-button-prev" style="margin-left: 61%;margin-top: -246px;" id="arrL"></div>
					<div class="swiper-button-next" style="margin-right: 31%;margin-top: -246px" id="arrR"></div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import Swiper from 'swiper';

	var _this;
	var mySwiper3;
	var tempage = [];
	//--------------------------------------------------------------模拟数据------------------------------------------
	var arr = []
	var arrInfo = []

	//-----------------------------------------------------------------------------------------------------------
	export default {
		name: 'warTeam',
		data() {
			return {
				msg: '战队简介',
				isActive: false,
				ifshowarrow: 1,
				teamData: '',
				teamDataInfo: '',
				ifShowArrow: false,
				ifshowteamInfo: true,
				allcover: false,
				itemiActive: 0,
				activeNum: '',
				coverteaminfo: [],
				tempteampeoplist: '',
				tempteampeoplistAll: '',
				tempT: [],
				teamindex: 0,
				tempages: '',
				showactiveshow: 1,
				allteamnum: 0,
				TMID: 0,
				TMN: 0,
			}
		},
		//监听
		watch: {
			allcover: function(e) {
				if(e) {
					setTimeout(function() {
						$('.swiper-slide-active .CBC1').addClass('animated fadeInLeft')
						$('.swiper-slide-active .CBC2').addClass('animated fadeInUp')
					}, 0)
				} else {
					$('.swiper-slide-active .CBC1').removeClass('animated fadeInLeft')
					$('.swiper-slide-active .CBC2').removeClass('animated fadeInUp')
				}
			}
		},
		//事件处理
		methods: {

			showTeamInfo: function(indexN, idN, fatherindex) {
				$('#arrR').removeClass('swiper-button-white');
				$('#arrL').removeClass('swiper-button-white');
				if((fatherindex + 1) != Math.ceil(_this.allteamnum / 4)) {
					_this.showactiveshow = indexN + 1;
				} else {
					if(_this.allteamnum % 4 == 3) {
						if(indexN == 0) {
							_this.showactiveshow = 5;
						}
						if(indexN == 1) {
							_this.showactiveshow = 6;
						}
						if(indexN == 2) {
							_this.showactiveshow = 7;
						}
					} else if(_this.allteamnum % 4 == 2) {
						if(indexN == 0) {
							_this.showactiveshow = 8;
						}
						if(indexN == 1) {
							_this.showactiveshow = 9;
						}
					} else if(_this.allteamnum % 4 == 1) {
						if(indexN == 0) {
							_this.showactiveshow = 10;
						}
					}

				}
				this.request.get({
					url: '/about/member?condition=status=0&condition=Team__id=' + idN,
					params: {},
					callback: function(data) {
						_this.tempT = data.data;
						_this.TMN = data.data.length;
						_this.teamindex = Number(indexN) + fatherindex * 4;
						_this.itemiActive = indexN;
						_this.ifshowteamInfo = false;
						var newthecooperArrInfo = [];
						if(_this.tempT.length == 0) {
							_this.ifshowteamInfo = true;
							_this.showactiveshow = 0;
							return;
						} else {
							_this.tempteampeoplist = _this.tempT;
							var tempnumInfo = _this.tempteampeoplist.length / 5;
							for(var t = 0; t < Math.ceil(tempnumInfo); t++) {
								newthecooperArrInfo[t] = []
								for(var r = 0; r < 5; r++) {
									if(_this.tempteampeoplist[(5 * t + r)] == undefined) {
										break;
									} else {
										newthecooperArrInfo[t].push(_this.tempteampeoplist[(5 * t + r)])
									}
								}
							}
							_this.teamDataInfo = newthecooperArrInfo;
						}

					}.bind(this)
				})

			},

			showallcover: function(num, parentnum) {
				//判断左右箭头的颜色
				if(num == 0 && parentnum == 0 && _this.TMN / 5 > 0) {
					$('#arrL').addClass('swiper-button-white')
				} else {
					$('#arrL').removeClass('swiper-button-white')
				}
				if((num + 5 * parentnum + 1) == _this.TMN) {
					$('#arrR').addClass('swiper-button-white')
				} else {
					$('#arrR').removeClass('swiper-button-white')
				}

				_this.initSwiper();
				var tindex = Number(num) + parentnum * 5
				var agenum = _this.tempT.length
				//计算年龄
				for(var i = 0; i < agenum; i++) {
					_this.tempT[i].birthday.split('-')[0]
					tempage.push(2018 - _this.tempT[i].birthday.split('-')[0])
				}
				_this.tempages = tempage;
				_this.coverteaminfo = _this.tempT; //获取弹出层数据
				//跳转到滚动相对应的页码
				_this.gettheteam(tindex);

			},
			gettheteam: function(num) {
				//跳转到轮播的页码
				mySwiper3.slideToLoop(num, 5000, false);
				_this.allcover = true;
			},
			initSwiper: function() {
				mySwiper3 = new Swiper('.swiper-container3', {
					onSlideChangeEnd: function(swiper) {
						swiper.update();
						mySwiper3.startAutoplay();
						mySwiper3.reLoop();
					},
					on: {
						init: function() {
							$('.swiper-slide-active .CBC1').addClass('animated fadeInLeft')
							$('.swiper-slide-active .CBC2').addClass('animated fadeInUp')
						},
						slideChangeTransitionStart: function() {
							$('.CBC1,.CBC2').removeClass('animated fadeInLeft fadeInUp')
							$('.swiper-slide-active .CBC1').addClass('animated fadeInLeft')
							$('.swiper-slide-active .CBC2').addClass('animated fadeInUp')
							_this.activeNum = this.activeIndex;
							if(this.activeIndex == 0) {
								$('#arrL').addClass('swiper-button-white')
							} else {
								$('#arrL').removeClass('swiper-button-white')
							}
							if(this.activeIndex == (_this.TMN - 1)) {
								$('#arrR').addClass('swiper-button-white')
							} else {
								$('#arrR').removeClass('swiper-button-white')
							}
						},
						slideChangeTransitionEnd: function() {},
					},
					observer: true,
					observeParents: true,
					pagination: {
						el: '.swiper-container3 .swiper-pagination',
					},
					navigation: {
						nextEl: '.swiper-container3 .swiper-button-next',
						prevEl: '.swiper-container3 .swiper-button-prev',
					},
				})
			},
			requestTeamList: function(offset) {
				this.request.get({
					url: '/about/team?condition=status=0',
					params: {},
					callback: function(data) {
						if(data.data.length == 0) return;
						_this.allteamnum = data.data.length;
						_this.tempteampeoplistAll = data.data;
						_this.TMID = data.data[0].id
						if(data.data[0].members == undefined) {
							_this.ifshowteamInfo = true;
						}
						if(data.data.length < 4) {
							if(data.data.length == 3) {
								_this.showactiveshow = 5;
							}
							if(data.data.length == 2) {
								_this.showactiveshow = 8;
							}
							if(data.data.length == 1) {
								_this.showactiveshow = 10;
							}
							if(data.data.length == 0) {
								_this.showactiveshow = 0;
							}
						}
						//战队轮播数据
						var newthecooperArr = [];
						var tempnum = data.data.length / 4;
						for(var t = 0; t < Math.ceil(tempnum); t++) {
							newthecooperArr[t] = []
							for(var r = 0; r < 4; r++) {
								if(data.data[(4 * t + r)] == undefined) {
									break;
								} else {
									newthecooperArr[t].push(data.data[(4 * t + r)])
								}
							}
						}
						_this.teamData = newthecooperArr;
						this.request.get({
							url: '/about/member?condition=status=0&condition=Team__id=' + _this.TMID,
							params: {},
							callback: function(data) {
								_this.tempT = data.data;
								_this.TMN = data.data.length;
								_this.ifshowteamInfo = false;
								var newthecooperArrInfo = [];
								if(_this.tempT.length == 0) {
									_this.ifshowteamInfo = true;
									_this.showactiveshow = 0;
									return;
								} else {
									_this.tempteampeoplist = _this.tempT;
									var tempnumInfo = _this.tempteampeoplist.length / 5;
									for(var t = 0; t < Math.ceil(tempnumInfo); t++) {
										newthecooperArrInfo[t] = []
										for(var r = 0; r < 5; r++) {
											if(_this.tempteampeoplist[(5 * t + r)] == undefined) {
												break;
											} else {
												newthecooperArrInfo[t].push(_this.tempteampeoplist[(5 * t + r)])
											}
										}
									}
									_this.teamDataInfo = newthecooperArrInfo;
								}
							}.bind(this)
						})
						//判断是否显示左右按钮
						if(_this.teamData.length > 1) {
							_this.ifShowArrow = true;
						} else {
							_this.ifShowArrow = false;
						}
					}.bind(this)
				})
			},
		},
		//实例加载完成后
		created() {
			//---获取战队
			this.requestTeamList()
		},
		//页面完成以后
		mounted: function() {
			_this = this;
			this.isActive = true;
			//--------战队轮播
			new Swiper('.swiper-container1', {
				slidesPerView: 1,
				observer: true,
				observeParents: true,
				navigation: {
					nextEl: '.swiper-container1 .swiper-button-next',
					prevEl: '.swiper-container1 .swiper-button-prev',
				},
			})
			//--------队员轮播
			new Swiper('.swiper-container2', {
				observer: true,
				observeParents: true,
				pagination: {
					el: '.swiper-container2 .swiper-pagination',
					clickable: true,
				},
			})
		},
	}
</script>

<style scoped>
	.bread {
		position: relative;
		margin-top: 20px;
		margin-left: 15%;
		height: 36px;
		width: 290px;
		line-height: 36px;
		background-size: cover;
		font-size: 24px;
	}
	
	.bread>img {
		height: 36px;
		width: 290px;
	}
	
	.bread>div {
		position: absolute;
		top: 0;
		left: 0;
	}
	
	.bread div span {
		margin-left: 5px;
		display: inline-block;
		vertical-align: middle;
	}
	
	.bread div img {
		display: inline-block;
		vertical-align: middle;
	}
	
	.topwordactive {
		animation: lightSpeedIn 1s;
	}
	
	#warTeam {
		background: url(../images/bg.png);
	}
	
	.box {
		margin: 0 auto;
		width: 1140px;
		text-align: center;
	}
	
	.topword {
		padding: 0;
		margin: 0;
		font-weight: bold;
		font-size: 40px;
	}
	
	.content {
		margin-top: 20px;
	}
	
	.swiper-container1 {
		width: 1150px;
		height: 200px;
	}
	
	.Lpic {
		width: 228px;
		height: 130px;
		box-shadow: 0px 0px 14px #e2e2e2;
	}
	
	.Lbox {
		position: relative;
		float: left;
		margin-right: 32px;
	}
	
	.playerinTeam1 {
		text-align: center;
		display: none;
		color: #a6a6a6;
		font-size: 18px;
		position: absolute;
		z-index: 1000;
		background-color: white;
		top: -20px;
		left: 52px;
		width: 228px;
		height: 27px;
		line-height: 40px;
		border-left: 1px solid #e2e2e2;
		border-right: 1px solid #e2e2e2;
	}
	
	.playerinTeam2 {
		text-align: center;
		display: none;
		color: #a6a6a6;
		font-size: 18px;
		position: absolute;
		z-index: 1000;
		background-color: white;
		top: -20px;
		left: 314px;
		width: 228px;
		height: 27px;
		line-height: 40px;
		border-left: 1px solid #e2e2e2;
		border-right: 1px solid #e2e2e2;
	}
	
	.playerinTeam3 {
		text-align: center;
		display: none;
		color: #a6a6a6;
		font-size: 18px;
		position: absolute;
		z-index: 1000;
		background-color: white;
		top: -20px;
		left: 576px;
		width: 228px;
		height: 27px;
		line-height: 40px;
		border-left: 1px solid #e2e2e2;
		border-right: 1px solid #e2e2e2;
	}
	
	.playerinTeam4 {
		text-align: center;
		display: none;
		color: #a6a6a6;
		font-size: 18px;
		position: absolute;
		z-index: 1000;
		background-color: white;
		top: -20px;
		left: 838px;
		width: 228px;
		height: 27px;
		line-height: 40px;
		border-left: 1px solid #e2e2e2;
		border-right: 1px solid #e2e2e2;
	}
	
	.playerinTeam5 {
		text-align: center;
		display: none;
		color: #a6a6a6;
		font-size: 18px;
		position: absolute;
		z-index: 1000;
		background-color: white;
		top: -20px;
		left: 183px;
		width: 228px;
		height: 27px;
		line-height: 40px;
		border-left: 1px solid #e2e2e2;
		border-right: 1px solid #e2e2e2;
	}
	
	.playerinTeam6 {
		text-align: center;
		display: none;
		color: #a6a6a6;
		font-size: 18px;
		position: absolute;
		z-index: 1000;
		background-color: white;
		top: -20px;
		left: 445px;
		width: 228px;
		height: 27px;
		line-height: 40px;
		border-left: 1px solid #e2e2e2;
		border-right: 1px solid #e2e2e2;
	}
	
	.playerinTeam7 {
		text-align: center;
		display: none;
		color: #a6a6a6;
		font-size: 18px;
		position: absolute;
		z-index: 1000;
		background-color: white;
		top: -20px;
		left: 707px;
		width: 228px;
		height: 27px;
		line-height: 40px;
		border-left: 1px solid #e2e2e2;
		border-right: 1px solid #e2e2e2;
	}
	
	.playerinTeam8 {
		text-align: center;
		display: none;
		color: #a6a6a6;
		font-size: 18px;
		position: absolute;
		z-index: 1000;
		background-color: white;
		top: -20px;
		left: 314px;
		width: 228px;
		height: 27px;
		line-height: 40px;
		border-left: 1px solid #e2e2e2;
		border-right: 1px solid #e2e2e2;
	}
	
	.playerinTeam9 {
		text-align: center;
		display: none;
		color: #a6a6a6;
		font-size: 18px;
		position: absolute;
		z-index: 1000;
		background-color: white;
		top: -20px;
		left: 576px;
		width: 228px;
		height: 27px;
		line-height: 40px;
		border-left: 1px solid #e2e2e2;
		border-right: 1px solid #e2e2e2;
	}
	
	.playerinTeam10 {
		text-align: center;
		display: none;
		color: #a6a6a6;
		font-size: 18px;
		position: absolute;
		z-index: 1000;
		background-color: white;
		top: -20px;
		left: 445px;
		width: 228px;
		height: 27px;
		line-height: 40px;
		border-left: 1px solid #e2e2e2;
		border-right: 1px solid #e2e2e2;
	}
	
	.activeshow {
		display: block;
	}
	
	.Lbox:hover {
		cursor: pointer;
	}
	
	.Lword {
		display: inline-block;
		text-align: center;
		height: 44px;
		line-height: 44px;
		width: 228px;
		background-color: white;
		border: 1px solid #e2e2e2;
		margin-top: 10px;
		color: black;
		font-size: 20px;
		font-weight: bold;
		cursor: pointer;
		box-shadow: 0px 0px 14px #e2e2e2;
	}
	
	.Lword:hover {
		background-color: #e2e2e2;
	}
	
	.theArrow {
		display: none;
	}
	
	.teamInfo {
		margin: 0px auto;
		width: 1110px;
		height: 300px;
		background-color: white;
		border: 1px solid #e2e2e2;
		padding-top: 56px;
		transition: .5s;
		opacity: 1;
		box-shadow: 0px 0px 14px #e2e2e2;
	}
	
	.activeteamInfo {
		opacity: 0;
	}
	
	.bgActive {
		color: #428bca;
	}
	
	.swiper-container2 {
		width: 1100px;
		height: 300px;
	}
	
	.swiper-pagination .swiper-pagination-bullet {
		border-radius: 5px;
		width: 20px;
	}
	
	.teammemberpic {
		width: 166px;
		height: 166px;
		border-radius: 50%;
	}
	
	.Lbox1 {
		float: left;
		margin-right: 32px;
		width: 176px;
		padding-top: 10px;
	}
	
	.Lbox1 div {
		width: 166px;
		height: 28px;
		text-align: center;
		line-height: 28px;
		font-size: 22px;
	}
	
	.Lbox1:hover {
		background-color: #e2e2e2;
		cursor: pointer;
	}
	
	.CoverBox {
		margin-top: 150px;
		height: 600px;
		width: 100%;
		min-width: 900px;
	}
	
	.swiper-container3 {
		width: 100%;
		height: 600px;
	}
	
	.CoverBoxI {
		width: 1000px;
		height: 526px;
		display: inline-block;
		margin-top: 36px;
	}
	
	.CBI {
		float: left;
		width: 350px;
		height: 526px;
	}
	
	.CBI img {
		width: 350px;
		height: 526px;
	}
	
	.CBC {
		padding-left: 80px;
		float: left;
		width: 450px;
		height: 526px;
		text-align: left;
		position: relative;
	}
	
	.CBC>div:nth-child(1) {
		color: white;
		font-style: oblique;
	}
	
	.CBC>div:nth-child(1) p:nth-child(1) {
		font-size: 30px;
	}
	
	.CBC>div:nth-child(1) p:nth-child(2) {
		font-size: 24px;
	}
	
	.CBC>div:nth-child(2) div {
		margin-top: 20px;
		color: white;
		font-size: 18px;
		height: 264px;
		overflow: auto;
	}
	
	.CBC>div:nth-child(1) {
		position: absolute;
		left: -50px;
	}
	
	.CBC>div:nth-child(2) {
		position: absolute;
		top: 200px;
		color: #b8b6b6;
		font-size: 16px;
	}
</style>
<style>
	.swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet {
		width: 40px;
		height: 10px;
		border-radius: 10px;
		margin-bottom: 10px;
	}
	
	.swiper-container-horizontal>.swiper-pagination-bullets,
	.swiper-pagination-custom,
	.swiper-pagination-fraction {
		bottom: 0px;
	}
	
	.swiper-container1 .swiper-button-prev {
		background-image: url("../images/icon/ban_pre.png");
		background-size: cover;
		height: 110px;
		width: 40px;
		top: 26%;
	}
	
	.swiper-container1 .swiper-button-next {
		background-image: url("../images/icon/ban_next.png");
		background-size: cover;
		height: 110px;
		width: 40px;
		top: 26%;
	}
</style>


// WEBPACK FOOTER //
// src/components/warTeam.vue